<template>
  <div class="relative inline-block">
    <div class="p-2 cursor-pointer" @click="toggle">
      <font-awesome-icon
        icon="ellipsis-v"
        v-if="!open"
      ></font-awesome-icon>
    </div>
    <div
      class="
        absolute
        bg-white
        rounded
        shadow
        z-10
        border border-gray-100
        right-0
        top-0
      "
      v-if="open"
      style="min-width: 60px"
    >
      <div class="flex flex-col" style="direction: rtl">
        <div
          class="cursor-pointer flex flex-row items-center m-2"
          @click="toggle"
          style="direction: ltr"
        >
          <p class="flex-grow text-text font-medium p-2">Menu</p>
          <font-awesome-icon icon="times" class="text-red"></font-awesome-icon>
        </div>
        <div class="flex flex-col" style="direction: ltr">
          <div v-for="action in actions" :key="action.label">
            <hr class="w-full my-1" v-if="typeof action === 'string'" />
            <div
              v-if="typeof action === 'object'"
              :class="`p-2 hover:bg-gray-100 cursor-pointer rounded ${
                action.class || ''
              }`"
              @click="
                action.action(contextData);
                toggle();
              "
            >
              {{ action.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "BooleanValue",
  props: ["actions", "contextData"],
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
});
</script>


